/* 🤖 this file was generated by svg-to-ts*/
export const iconQuiz = {
  name: 'quiz',
  data: `<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><path d="M11.047 20.265v-6.056H7.43c-.504 0-.844-.586-.599-1.068l5.005-10.49c.313-.687 1.279-.438 1.279.337v6.13h3.454c.504 0 .83.57.612 1.053L12.34 20.587c-.327.702-1.293.453-1.293-.322z"/></svg>`,
}
